module.exports = "<div class=\"loading-overlay\" [hidden]=\"!isShow\">\n  <span class=\"loading-image\"></span>\n</div>\n"